class AriaActClass {
	constructor() {


		this.customEvents = {
			expandOpen: (detail) => new CustomEvent('AriaAct:expandOpen', { bubbles: true, detail: { ...detail } }),
			expandClose: (detail) => new CustomEvent('AriaAct:expandClose', { bubbles: true, detail: { ...detail } })
		}

		this.eventListeners = {
			click: () => document.body.addEventListener('click', this._router.bind(this), false),
			mouseOver: () => document.body.addEventListener('mouseover', this._router.bind(this), false),
			mouseOut: () => document.body.addEventListener('mouseout', this._router.bind(this), false),
			dblClick: () => document.body.addEventListener('dblclick', this._router.bind(this), false),
			hover: () => {
				this.eventListeners.mouseOver && this.eventListeners.mouseOver() && (this.eventListeners.mouseOver = false);
				this.eventListeners.mouseOut && this.eventListeners.mouseOut() && (this.eventListeners.mouseOut = false);
			}
		}

		this.registered = [];
		this.focusableElements = ['button', 'a', 'input', 'select', 'textarea', '[tabindex]'];
	}

	registerListener(eventType, selector, action) {
		if (typeof this[action] !== "function") {
			console.warn('Invalid Action registration:', action)
			return false;
		}

		if (typeof this.eventListeners[eventType] !== "function") {
			console.warn('Invalid Event registration:', eventType)
			return false;
		}

		// Creates the event listener but only if it's not already created
		this.eventListeners[eventType] && this.eventListeners[eventType]() && (this.eventListeners[eventType] = false)

		return this.registered.push({
			eventType: eventType,
			sel: selector,
			action: action,
			trigger: null,
			targets: null,
			event: null,
		})
	}

	_router(e) {
		if (!this.registered.length) return;

		let subscribed = ['mouseover', 'mouseout'].includes(e.type)
			? this.registered.filter(listener => listener.eventType === 'hover' && e.target.closest(listener.sel))
			: this.registered.filter(listener => listener.eventType === e.type && e.target.closest(listener.sel))

		subscribed.length && e.stopImmediatePropagation();

		subscribed.forEach(listener => {
			listener.trigger = e.target.closest(listener.sel);
			listener.event = e;
			this[listener.action](listener);
		})

		return true;
	}

	expandOpen(listener) {
		return this.expandToggle(listener, true)
	}

	expandClose(listener) {
		return this.expandToggle(listener, false)
	}

	expandToggle(listener, forceState = null) {
		const { trigger, event } = listener;
		const isIndirectCall = !event;

		if (!trigger || !trigger.hasAttribute("aria-controls")) {
			console.warn('Invalid trigger or aria-controls not set:', trigger)
			return false;
		}
		const targets = this.getTargets(trigger);
		const triggerControls = trigger.getAttribute('aria-controls');
		const isClosing = forceState === null ? trigger.getAttribute("aria-expanded") === "true" : !forceState;

		if (!targets) {
			console.warn('Trigger points to nowhere:', trigger)
			return false
		}

		// chages expanded state of the trigger and correlated triggers
		document.querySelectorAll(`[aria-controls="${triggerControls}"]`).forEach( el => {
			el.setAttribute('aria-expanded', isClosing ? "false" : "true")
		})

		// if it's closing, we must remove focus from the trigger and focus in the opener button.
		if( isClosing ){
			trigger.blur();
			if( trigger.dataset.aria !== 'opener' && ! isIndirectCall){
				document.querySelector(`[data-aria="opener"][aria-controls="${triggerControls}"]`)?.focus()
			}
		}

		// if trigger has the attribute 'aria-haspopup="dialog"', means we are handling a modal.
		const isModal = trigger.getAttribute('aria-haspopup') === 'dialog';

		// if it is a modal controller, we set all body elements as inert except the modal
		isModal && this.inertPage(targets, !isClosing);

		targets.forEach(target => {
			if(isClosing ){
				target.setAttribute('aria-hidden',"true")
				target.setAttribute('inert','')
			}else{
				target.setAttribute('aria-hidden',"false")
				target.removeAttribute('inert')
				this.focusInnerTarget(target)
			}
		})

		listener.targets = targets;

		let fireEvent = isClosing ? this.customEvents.expandClose(listener) : this.customEvents.expandOpen(listener)
		window.dispatchEvent(fireEvent)

		return listener;
	}

	closeOthersOnOpen(listener) {
		const { trigger, sel } = listener;
		trigger.getAttribute('aria-expanded') === "true" && document.querySelectorAll(sel)?.forEach(el => {
			!el.closest(`[aria-controls="${trigger.getAttribute('aria-controls')}"]`) && this.expandClose({ trigger: el })
		})
		return listener
	}

	maybeScrollTo(listener, delay, onlyIfNotInViewPort = true, margin, offset, behavior = "smooth", parent = window) {
		setTimeout(() => {
			onlyIfNotInViewPort && !this.isInViewport(listener.trigger, margin, offset) && parent.scrollTo({
				top: listener.trigger.getBoundingClientRect().top + parent.scrollY - offset,
				behavior: behavior
			})
		}, delay);
	}

	// Helpers
	getTargets(trigger) {
		let ids = trigger.getAttribute('aria-controls')
		ids = ids.split(' ');
		ids = '#' + ids.join(', #');
		return document.querySelectorAll(ids);
	}

	focusInnerTarget(target, focusableElements = this.focusableElements) {
		let focusSelector = focusableElements && focusableElements.join(':not([tabindex="-1"]), ') + ':not([tabindex="-1"])';
		focusSelector && target.querySelector(focusSelector)?.focus()
	}

	isInViewport(el, margin = {}, offset = {}) {
		if (!el) return false;

		margin.top = margin?.top ?? 0;
    margin.bottom = margin?.bottom ?? 0;
    margin.left = margin?.left ?? 0;
    margin.right = margin?.right ?? 0;

		offset.top = offset?.top ?? 0;
    offset.bottom = offset?.bottom ?? 0;
    offset.left = offset?.left ?? 0;
    offset.right = offset?.right ?? 0;

		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 - offset.top + margin.top &&
			rect.left >= 0 - offset.left + margin.left &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset.bottom + margin.bottom &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth) - offset.right + margin.right
	);
	}

	inertPage(exclude, inert = true) {

		if (inert) {
			let bodyRoot = Array.from(document.body.children).filter(el => el.parentElement === document.body && !Array.from(exclude).includes(el));
			bodyRoot.forEach(el => !el.hasAttribute('inert') && el.setAttribute('data-inert', exclude[0].id));
			const removeInertFromAncestors = async (element, inertId) => {

				let parent = element.closest(`[data-inert="${inertId}"]`);
				if (!parent) return;

				// Remove 'inert' from the parent itself
				parent.removeAttribute('data-inert');

				// Inert all siblings except the excluded ones
				let siblings = Array.from(parent.children).filter(sibling => sibling.parentElement === parent && !Array.from(exclude).includes(sibling));
				siblings.forEach(sibling => !sibling.hasAttribute('inert') && sibling.setAttribute('data-inert', inertId));

				// Move up the DOM tree
				await removeInertFromAncestors(element, inertId);

			}
			exclude.forEach( async el => {
				await removeInertFromAncestors(el, el.id)
				let tempInerts = document.querySelectorAll(`[data-inert="${el.id}"]`);
				tempInerts && tempInerts.forEach(el => {
					el.setAttribute('inert', '');
				})
			});
		} else {
			// Restore elements that were set to inert
			exclude.forEach(el => {
				let removeInertFrom = document.querySelectorAll(`[data-inert="${el.id}"]`);
				removeInertFrom && removeInertFrom.forEach(el => {
					el.removeAttribute('data-inert');
					el.removeAttribute('inert');
				})
			})
		}


	}
}

const AriaAct = new AriaActClass();
export default AriaAct;
